import { useTranslation } from "react-i18next";

import BaseSkeleton from "@/components_v2/Skeleton/BaseSkeleton";
import BaseSkeletonGroup from "@/components_v2/Skeleton/BaseSkeletonGroup";

import "./styles.css";

const STAT_CARDS = 4;
const TABLE_ROWS = 6;

const AdminSkeleton = () => {
  const { t } = useTranslation();

  return (
    <BaseSkeletonGroup
      label={t("labels.loading")}
      className="flex flex-col gap-500"
    >
      <div className="flex flex-col gap-200">
        <BaseSkeleton width="16rem" />

        <BaseSkeleton width="20rem" height="var(--spacing-500)" />
      </div>

      <div className="flex flex-wrap gap-300">
        {Array.from({ length: STAT_CARDS }, (_, index) => (
          <div
            key={index}
            className="admin-stat-card flex-1 flex flex-col gap-200"
          >
            <BaseSkeleton width="8rem" />

            <BaseSkeleton width="3rem" height="var(--spacing-500)" />
          </div>
        ))}
      </div>

      <BaseSkeleton width="28rem" />

      <div className="flex flex-col gap-300">
        {Array.from({ length: TABLE_ROWS }, (_, index) => (
          <BaseSkeleton key={index} height="var(--spacing-600)" />
        ))}
      </div>
    </BaseSkeletonGroup>
  );
};

export default AdminSkeleton;
